<template>
  <div class="share-dialog">
    <a-popover v-model="visible" trigger="click" placement="bottom">
      <div slot="content" class="share-icon">
        <!-- <div :class="visible?'share-lt cur':'share-lt'"> -->
        <div ref="share" class="social-share"></div>
        <!-- <share :config="config"><span class="link" @click="copy"></span></share> -->
        <span class="link" @click="copy"></span>
        <!-- <span class="wx"></span>
        <span class="wb"></span> -->
        <!-- <span class="link" @click="copy"></span> -->
        <!-- </div> -->
      </div>
      <slot></slot>
    </a-popover>
  </div>
</template>

<script>

import '@/assets/socialshare/share.css';
import '@/assets/socialshare/iconfont.css';
require('@/assets/share/js/social-share.js')

export default {
  name: 'ShareDialog',
  props: {
    shareConfig: {
      type: Object,
      default: null
    }
  },
  data(){
    return {
      visible:false,
      config: {
        url: '', // 网址，默认使用 window.location.href
        source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: '', // 图片, 默认取网页中第一个img标签
        sites: ['wechat', 'qq', 'qzone', 'weibo' ],
        // sites: ['wechat', 'qq', 'qzone' ],
        // disabled: ['google', 'facebook', 'twitter'], // 禁用的站点
        // wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
        // wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>'
      }
    }
  },
  created() {
    if (this.shareConfig && this.shareConfig.url) {
      this.config.url = this.getUrl(this.shareConfig.url)
    } else {
      this.config.url = window.location.href.split("#")[0];
    }
    if (this.shareConfig && this.shareConfig.title) {
      this.config.title = this.shareConfig.title
    } else {
      this.config.title = document.title;
    }
    if (this.shareConfig && this.shareConfig.image) {
      this.config.image = this.shareConfig.image
    } else {
      this.config.image = '';
    }
  },
  mounted() {
    // console.log(this.shareConfig)
    // //console.log(window.socialShare)
    // window.socialShare(this.$refs.share, this.config)
  },
  methods:{
    getUrl(url) {
      if (url.indexOf(window.location.protocol) == 0) {
        return url.split("#")[0];
      } else {
        return window.location.protocol+"//"+window.location.host+url.split("#")[0];
      }
    },
    show() {
      this.visible = true;
      this.$nextTick(()=>{
        window.socialShare(this.$refs.share, this.config)
      });
    },
    copy(){
      this.$copyText(this.config.url).then((e) => {
        this.$message.open({
          content:'复制成功！',
          icon:<img style="width:14px;height:14px;margin-right:5px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgBpZFNbsIwEIVnvEBZplL/dqUnqHqD3qDpBsyuPUF7g6Q3oCeougOvygm4AtwgOyQiBFsEzDC2CAo/gZA8yYn9xv409kPIaBoE/sLzAiR6UIgzGb2rTie2tZHW9RrzKzH7BDCsKTVIa1aYTsat1pciChnAh121ZROK/5k1xYuXzD/3xrS3oLHW78j8CyUkHb7dGfOv7EIxh1BSAnANYKL1CzD3oYLmRM9K7l6HivIQnxSsVgOoKGaO3WMnzeYUDtMqBpH0brvdR/fYktgHlJQEFbm//Vzb+DbGZe1wJGf/XDNZf9JohIQYFYXcGPOdLnG/Xgi2BzkKOgs7AskF5cJyICdBB7ATkEKysETGuX1rfziAH44aflAAAAAASUVORK5CYII=" />
        });
      })
    }
  },
  watch: {
    shareConfig: function(shareConfig, oldVal){
      if (shareConfig && shareConfig.url) {
        this.config.url = this.getUrl(shareConfig.url)
      } else {
        this.config.url = window.location.href.split("#")[0];
      }
      if (shareConfig && shareConfig.title) {
        this.config.title = shareConfig.title
      } else {
        this.config.title = document.title;
      }
      if (shareConfig && shareConfig.image) {
        this.config.image = shareConfig.image
      } else {
        this.config.image = '';
      }
    }
  }

}
</script>